import { useContext, useMemo } from "react";
import { TerminationsWizardContext } from "@app/terminations/import/TerminationsWizardContext";
import { BulkCreateProviderTerminationsModel } from "@app/terminations/import/interfaces";

export const useBulkTerminationModel = (): BulkCreateProviderTerminationsModel => {
  const context = useContext(TerminationsWizardContext);
  const model = useMemo<BulkCreateProviderTerminationsModel>(() => {
    return {
      bulkProviderTerminationId: context.bulkProviderTerminationId,
      bulkProviderTerminationMethod: context.bulkProviderTerminationMethod,
      customProjectIds: context.eligibleSelectedProjectIds.map((id) => parseInt(id, 10)),
      emailOnSuccess: context.emailOnSuccess,
      exportName: context.filename,
      formatType: context.formatType,
      includedReports: Object.assign({}, context.includedReports, ...Object.entries(context.selectedReportPreset).map(([key, value]) => ({ [`${key}ReportCustomizationId`]: value.id }))),
      isDistinctServicingProviderReport: context.isDistinctServicingProviderReport,
      lineOfBusiness: context.selectedLineOfBusiness,
      projectType: context.projectType,
      reasonDescription: context.comment,
      reasonName: context.terminationReason,
      shouldSkipTerminationTimeDistanceRecalc: context.shouldSkipTerminationTimeDistanceRecalc,
      terminateByAllLocations: context.terminateByAllLocations,
      terminateByAllSpecialties: context.terminateByAllSpecialties,
      terminateByNpi: context.terminateByNpi,
      terminateByTin: context.terminateByTin,
    };
  }, [
    context.bulkProviderTerminationId,
    context.bulkProviderTerminationMethod,
    context.eligibleSelectedProjectIds,
    context.emailOnSuccess,
    context.filename,
    context.formatType,
    context.includedReports,
    context.isDistinctServicingProviderReport,
    context.projectType,
    context.selectedLineOfBusiness,
    context.comment,
    context.selectedReportPreset,
    context.shouldSkipTerminationTimeDistanceRecalc,
    context.terminationReason,
    context.terminateByAllLocations,
    context.terminateByAllSpecialties,
    context.terminateByNpi,
    context.terminateByTin,
  ]);

  return model;
};
